import { render } from "./WarekiInput.vue?vue&type=template&id=6c5d68cc"
import script from "./WarekiInput.vue?vue&type=script&lang=js"
export * from "./WarekiInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/WarekiInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c5d68cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c5d68cc', __exports__)) {
    api.reload('6c5d68cc', __exports__)
  }
  
  module.hot.accept("./WarekiInput.vue?vue&type=template&id=6c5d68cc", () => {
    api.rerender('6c5d68cc', render)
  })

}


export default __exports__